import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'task',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_done',
      board_id: value.board_id,
      task_id: value.id,
    })
  }
}
